/**
 * 合同管理
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React,{PureComponent} from 'react';
import {Input, Button, Popover, Row, Col, Form,Space, message, Modal, Spin} from "antd";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import ContractService from "@services/ContractService";
import IconFont from "@components/IconFont/index";
import FetchTable from '@components/FetchTable/FetchTable';
import ModalFormComponent from '@components/ModalForm/ModalForm';
import Lang from "@/components/Lang/Lang";
import Locale from "@utils/locale";
import dayjs from "dayjs";
import {isEmpty,getFileSuffix} from '@utils/utils';
import "./ContractManagement.less";
const { Search } = Input;
class ContractManagement extends PureComponent{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            listQuery:{}, // 搜索Map
            list: [],
            // 表格
            pageSize: 10,
            columns:[
                {
                    cnTitle: '客户编码',
                    dataIndex: 'buyerCode',
                    cnTitleId: 'CaiGouShang',
                },
                {
                    cnTitle: '客户名称',
                    dataIndex: 'buyerName',
                    cnTitleId: 'KeHuMingCheng',
                },
                {
                    cnTitle: '合同编码',
                    dataIndex: 'code',
                    cnTitleId: 'HeTongBianMa',
                },
                {
                    cnTitle: '合同期限',
                    dataIndex: 'startTime',
                    cnTitleId: 'HeTongQiXian',
                    render: (startTime, record) => dayjs(startTime).format('YYYY-MM-DD')+ ' ~ '+ (!isEmpty(record.endTime)?dayjs(record.endTime).format('YYYY-MM-DD'):'')
                },
                {
                    cnTitle: '合同状态',
                    dataIndex: 'statusName',
                    cnTitleId: 'HeTongZhuangTai',
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 180,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (
                        <Space>
                            <Popover content={Lang({id: 'ChaKanHeTong',default:'查看合同'})}>
                                <a className="link" onClick={() => {
                                    this.handleViewFile(record);
                                }}>
                                    <IconFont
                                        type="icon-xiangqing-moren-icon"
                                        className="icon-action hover-hide"
                                    ></IconFont>
                                    <IconFont
                                        type="icon-xiangqing-xuanzhong-icon"
                                        className="icon-action hover-show"
                                    ></IconFont>
                                </a>
                            </Popover>
                            {record.status=='1'&&<Popover content={Lang({id: 'JieShuHeTong',default:'结束合同'})}>
                                <a className="link" onClick={() => {
                                    this.handleEndTheContract(record);
                                }}>
                                    <IconFont
                                        type="icon-jieshuhetong"
                                        className="icon-action hover-hide"
                                    ></IconFont>
                                    <IconFont
                                        type="icon-jieshuhetong-xuanzhong"
                                        className="icon-action hover-show"
                                    ></IconFont>
                                </a>
                            </Popover>}
                            {record.status=='1'&&<Popover content={Lang({id: 'BianJi',default:'编辑'})}>
                                <a className="link" onClick={() => {
                                    this.handleEdit(record);
                                }}>
                                    <IconFont
                                        type="icon-xiugai-1"
                                        className="icon-action hover-hide"
                                    ></IconFont>
                                    <IconFont
                                        type="icon-xiugai-2"
                                        className="icon-action hover-show"
                                    ></IconFont>
                                </a>
                            </Popover>}
                        </Space>

                    ),
                },
            ],
            // 弹窗
            options:[],
            title:{},
            fromInitialValues:{},
            actionType:'',//保存类型
            formItemLayout:{},
            showFilesPop:false,
        }
    }
    /**
     * 行编事件
     * **/
    changeFile = ({ target: { value } }, field ) => {
        value = value.trim();
        let newFieldList = {...this.state.listQuery};
            newFieldList[field] = value ? value : "";
        this.setState({
            listQuery: newFieldList,
        });
    };
    /**
     * 搜索事件
     * **/
    onSearch(value,pageSize){
        if(this.onPageTemplateTableChild){
            const pagingQuery = {
                pageIndex: 1,
                pageSize: pageSize
            }
            let send = {
                ...value,
                pagingQuery
            }
            this.onPageTemplateTableChild.handleFetch(send);
        }
    }
    /**
     * （查询）
     *
     * @param {Object} options 查询参数
     */
    getList(listQuery,callback){
        ContractService.queryList(listQuery).then(resp =>callback(resp));
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    // 调用 查询 模型/表格组件的方法
    onPageTemplateTableRef = (ref) => this.onPageTemplateTableChild = ref;
    /**
     * 查看合同
     * 打开文件 todo
     * **/
    handleViewFile(record){
        this.getContractFile({id:record.id},res=>{
                const resp = res.data ||{};
                const {success,valid,model}= resp;
                if(success,valid){
                    const contractFileList = model.contractFileList||[];
                    let flagFileOpen =false;
                    let picList = [];
                    let fileList = []
                    contractFileList.forEach(item=> { 
                       if(!isEmpty(item.fileUrl)){
                           flagFileOpen=true;
                           if(item.type=='document'){ // 合同已限制只能两件格式间 两选一
                               fileList.push(item)
                           }else picList.push(item)
                       }
                    } )

                    //  else{
                    //     const w=window.open('about:blank');
                    //     w.location.href="/sp/contractFiles?id="+record.id;
                    //     // this.props.history.push({pathname:"/contractManagement/files?id="+record.id,query:{id:record.id,fileList:fileList},});
                    // }
                    if(!flagFileOpen){message.warning(Lang({id: "ZanWuWenJian",default: "暂无文件",}));
                    }else if(fileList.length>0){
                        this.popFileShow(fileList,picList)
                    }else {
                        this.popPicShow(picList)
                    }
                }
        })
    }
    getContractFile(data,callback){
        ContractService.getContractFile(data).then(res=>callback(res))
    }
    /**
     * 新增合同
     ***/
    handleAdd(){
        this.setState({
            showModal:true,
            options:[
                {
                    name:'buyerId',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    required: true,
                    type:'SearchSelector',
                    searchClass:{
                        api:"/service/mg/fin/ddp/remittance-item/buyerList",
                        searchField: 'keyWord',
                        idField:'buyerId',
                        field:  [{ cnTitle: '客户编号',cnTitleId:'KeHuBianHao', dataIndex:'buyerCode'},{ cnTitle: '客户名称',cnTitleId:'KeHuMingCheng', dataIndex:'buyerName'},{ title: 'ID',dataIndex:'buyerId'},],
                    },
                },
                {
                    name:'companyName',
                    cnTitle:'公司名称',
                    cnTitleId:'GongSiMingCheng',
                },
                {
                    name:'taxRegistrationNo',
                    cnTitle:'税务号',
                    cnTitleId:'ShuiWuHao2',
                },
                {
                    name:'startTime',
                    cnTitle:'签订日期',
                    cnTitleId:'QianDingRiQi',
                    type:'Date',
                    required: true
                },
                {
                    name:'contractFileList',
                    cnTitle:'合同文件',
                    cnTitleId:'HeTongWenJian',
                    type:'UploadFile',
                    accept:'.pdf, .jpg, .jpeg, .png, .docx, .doc',
                    flagLimitType:true,
                    required: true
                }
            ],
            title:{
                cnTitle:'新增合同',
                cnTitleId:'XinZengHeTong',
            },
            fromInitialValues:{},
            actionType:'add',
        })
    }
    /**
     * 结束合同
     ***/
    handleEndTheContract(record){
        this.loading(true);
        const userLang = Locale.current();
        let configFileOpen ={
            showModal:true,
            title:{
                cnTitle:'结束合同',
                cnTitleId:'JieShuHetTong',
            },
            fromInitialValues:{
                id:record.id,
                endTime:''
            },
            formItemLayout:{
                labelCol: { span: userLang=='ru'?8:6 },
                wrapperCol: { span: userLang=='ru'?16:18 },
                labelAlign: 'left',
            },
            actionType:'end',
        }
        this.getContractFile({id:record.id},res=>{
            this.loading(false)
            const resp = res.data ||{};
            const {success,valid,model}= resp;
            if(success,valid){
                const contractFileList = model.contractFileList||[];
                const userFileType = contractFileList[0].type;
                const acceptType = userFileType=='pic'?'.jpg, .jpeg, .png,':'.pdf, .docx, .doc';
                configFileOpen['options'] =[
                    {
                        name:'id',
                        title:'ID',
                        required: true,
                        disabled:true,
                        hidden:true,
                    },
                    {
                        name:'endTime',
                        cnTitle:'合同结束日子',
                        cnTitleId:'HeTongJieShuRiZi',
                        type:'Date',
                        required: true
                    },
                    {
                        name:'contractFileList',
                        cnTitle:'合同文件',
                        cnTitleId:'HeTongWenJian',
                        type:'UploadFile',
                        accept: acceptType,
                        flagLimitType:true,
                        required: true
                    }
                ]
                this.setState(configFileOpen)
            }else message.warning(Lang({id:'WangLuoGuZhangHuoZheXiTon',default:'网络故障或者系统问题，服务暂不可用'}))
        })
    }
    /**
     * 编辑合同
     *
     **/
    handleEdit(record){
        let dat = { ...record}
        dat['startTime'] = dayjs(record.startTime);
        this.loading(true);
        let configFileOpen = {
            showModal:true,
            options:[
                {
                    name:'id',
                    title:'ID',
                    required: true,
                    disabled:true,
                    hidden:true,
                },
                {
                    name:'buyerId',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    required: true,
                    disabled:true,
                    hidden:true,
                },
                {
                    name:'buyerCode',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    required: true,
                    disabled:true,
                },
                {
                    name:'companyName',
                    cnTitle:'公司名称',
                    cnTitleId:'GongSiMingCheng',
                },
                {
                    name:'taxRegistrationNo',
                    cnTitle:'税务号',
                    cnTitleId:'ShuiWuHao2',
                },
                {
                    name:'startTime',
                    cnTitle:'签订日期',
                    cnTitleId:'QianDingRiQi',
                    type:'Date',
                    required: true
                },
                {
                    name:'contractFileList',
                    cnTitle:'合同文件',
                    cnTitleId:'HeTongWenJian',
                    type:'UploadFile',
                    accept:'.pdf, .jpg, .jpeg, .png, .docx, .doc',
                    flagLimitType:true,
                    required: true
                },

            ],
            title:{
                cnTitle:'合同编辑',
                cnTitleId:'HeTongBianJi',
            },
            actionType:'edit',
        }
        this.getContractFile({id:record.id},res=>{
            this.loading(false)
            const resp = res.data ||{};
            const {success,valid,model}= resp;
            if(success,valid){
                const contractFileList = model.contractFileList||[];
                dat['contractFileList'] = contractFileList;
                configFileOpen['fromInitialValues'] = dat;
            }


            this.setState(configFileOpen)
        })
    }
    /**
     * 保存弹窗数据
     *
     **/
    handleSave(actionType,dat){
        this.loading(true);
        switch(actionType){
            case 'end':
                const newEndTime = dayjs(dat.endTime).valueOf().toString();
                    dat['endTime'] = newEndTime;
                    ContractService.endContract(dat).then(res=>this.handleBackRes(res.data));
                break;
            case 'add':
                const newStartTime = dayjs(dat.startTime).valueOf().toString();
                    dat['startTime'] = newStartTime;
                    ContractService.editContract(dat).then(res=>this.handleBackRes(res.data));
                break;
            case 'edit':
                const editStartTime = dayjs(dat.startTime).valueOf().toString();
                dat['startTime'] = editStartTime;
                ContractService.editContract(dat).then(res=>this.handleBackRes(res.data));
                break;
        }
    }
    handleBackRes(res){
        const {success,valid}= res;
        this.loading(false);
        if(success&&valid){
            this.onPageTemplateTableChild.handleFetch();
            this.handleCancelPop()
        }else if(res.message){
            message.warning(res.message);
        } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
    }
    /**
     * 关闭弹窗
     *
     **/
    handleCancelPop(){
        this.setState({
            showModal:false,
            showPicPop:false,
            showFilesPop:false,
            title:{},
            fromInitialValues:{},
            formItemLayout:{},
            fileList:[],
            picList:[],
        })
    }
    /**
     * 图片
     ***/
    popPicShow(picList){
        this.setState({
            showPicPop:true,
            picList:picList,
        })
    }
    /**
     * 文件窗口
     * */
    popFileShow(fileList=[],picList=[]){
        this.setState({
            showFilesPop:true,
            fileList:fileList,
        })
    }
    renderPic(picList=[]){
        let children = [];
        let startFiles = picList.filter(item=>item.fromType==1);
        let endFiles = picList.filter(item=>item.fromType==0);
        if(startFiles.length>0) {
            children.push(<div key={'startFiles'} className={'file-title fw_500 font_15'}>{Lang({id: "HeTongWenJian",default: "合同文件",})}</div>)
            startFiles.forEach(item => children.push(<div className={'pop-contract-img'} key={item.fileId}>
                <img src={item.fileUrl}/>
            </div>))
        }
        if(endFiles.length>0){
            children.push(<div key={'endFiles'} className={'file-title fw_500 font_15'}>{Lang({id: "JieShuHetTong",default: "结束合同",})}</div>)
            endFiles.forEach(item => children.push(<div className={'pop-contract-img'} key={item.fileId}>
                <img src={item.fileUrl}/>
            </div>))
        }
        return children;
    }
    renderDocument(files=[]){
        let children = [];
        let startFiles = files.filter(item=>item.fromType==1);
        let endFiles = files.filter(item=>item.fromType==0);
        if(startFiles.length>0){
            children.push(<div className={'file-title fw_500 font_15'}>{Lang({id: "HeTongWenJian",default: "合同文件",})}</div>)
            startFiles.forEach((file,index)=>{
                const suffix = getFileSuffix(file.fileName);
                children.push(<Button key={index} className={"btn-file"} onClick={()=>{suffix==='pdf'?this.openPDF(file.fileUrl,file.fileId):this.openDocument(file)}}>{file.fileName}</Button>)
            })
        }
        if(endFiles.length>0){
            children.push(<div className={'file-title fw_500 font_15'}>{Lang({id: "JieShuHetTong",default: "结束合同",})}</div>)
            endFiles.forEach((file,index)=>{
                const suffix = getFileSuffix(file.fileName);
                children.push(<Button key={index} className={"btn-file"} onClick={()=>{suffix==='pdf'?this.openPDF(file.fileUrl,file.fileId):this.openDocument(file)}}>{file.fileName}</Button>)
            })
        }
        return children
    } /**
     * 打开文件
     **/
    async openDocument(item){
        this.loading(true);
        const res = await ContractService.getOneFile({id:item.fileId})||{};
        this.loading(false);
        const resp = res.data||{};
        const {success,valid}= resp;
        if(success&&valid) window.open(resp.model);
    }
    openPDF(url,id){
        window.open(url,id+'_blank')
    }
    componentDidMount() {
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { listQuery, loading, columns, pageSize, showModal,options,title,fromInitialValues,
            actionType,picList,showPicPop,formItemLayout,showFilesPop,fileList} = this.state;
        const currPageName =  Lang({id: "HeTongGuanLi",default: "合同管理"});

        return (<Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[{name:currPageName}]}></CommonBreadcrumb>
                <div className="page-contract-wrap">
                    <div className="search-box">
                        <div className="mb_12 new-link" data-flex="cross:center">
                            <span className="font-title fw_700 font_18 mr_10"> {currPageName}</span>
                            <div className="font-main cursor-p">
                                <div data-flex="cross:center" onClick={()=>this.handleAdd()}>
                                    <i className="ri-add-box-line mr_4"></i>
                                    <span className="font_14"> {Lang({id: "XinZengHeTong",default: "新增合同"})}</span>
                                </div>
                            </div>
                        </div>
                        <Form layout="inline">
                            <Row style={{ width: "100%" }}>
                                <Col span={7}>
                                    <Form.Item label="">
                                        <Search
                                            placeholder={ Lang({id: "QingShuRuCaiGouShangBianMaHuoMingCheng",default: "请输入客户编码或名称",})}
                                            style={{ width: "100%" }}
                                            loading={loading}
                                            value = {listQuery.customer}
                                            onChange={(e)=>this.changeFile(e,'keyword')}
                                            onSearch={()=>this.onSearch(listQuery,pageSize)}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    <div className="content-box">
                        <FetchTable columns={columns}
                                        fetchCondition={listQuery}
                                        pageSize={pageSize}
                                        onRef={this.onPageTemplateTableRef}
                                        fetchFunction={this.getList} />
                    </div>
                    {showModal&&<ModalFormComponent loading={loading}
                                                    showModal={showModal}
                                                    title={title}
                                                    width={600}
                                                    options={options}
                                                    formItemLayout={formItemLayout}
                                                    saveFormValue={this.handleSave.bind(this,actionType)}
                                                    initialValues={fromInitialValues}
                                                    handleCancel={this.handleCancelPop.bind(this)} />}
                    {showPicPop&&<Modal
                        title={ Lang({id: "HeTongWenJian",default: "合同文件",})}
                        centered
                        open={showPicPop}
                        onOk={() => this.handleCancelPop()}
                        onCancel={() => this.handleCancelPop()}
                        width={1000}
                    >
                        <div className={'pop-view-wrap'}>
                        {this.renderPic(picList)}
                        </div>
                    </Modal>}
                    {showFilesPop&&<Modal
                        title={ Lang({id: "HeTongWenJian",default: "合同文件",})}
                        centered
                        open={showFilesPop}
                        onOk={() => this.handleCancelPop()}
                        onCancel={() => this.handleCancelPop()}
                        width={600}
                    >
                        <div className={'pop-view-wrap'}>
                            {this.renderDocument(fileList)}
                        </div>
                    </Modal>}
                </div>
            </Spin>

        )
    }
}

export default ContractManagement;
